import React from "react";
import useWindowDimensions from "../../../get-diemensions/UseWindowDiemensions";
import { InfoCard } from "../../../components";
import { BaseButton } from "../../../components/atoms";

const InfoPanel = ({ onSignUpClick }) => {
  const { width, height } = useWindowDimensions();
  return (
    <div
      style={{
        width: width,
        maxWidth: 1440,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 40,
        marginBottom: 40,
        backgroundColor: "#F2FBFD",
      }}
    >
      <h2
        style={{
          paddingBottom: 20,
          textAlign: width > 599 ? "left" : "center",
        }}
      >
        Consider Quality, Safety and Efficacy
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            //   borderStyle: "solid",
            display: "flex",

            minHeight: 200,
            justifyContent: "space-between",
            flexDirection: width > 599 ? "row" : "column",
          }}
        >
          <InfoCard
            no={"1"}
            image={require("../../../images/landing/patientConsoltation.jpg")}
            title={"Patient Consultation"}
            paragraph={
              "Patients are assessed by a registered medical practitioner, who evaluates eligibility and initiates the Section 21 SAHPRA application. If approved, an applicable prescription is issued."
            }
          />
          <InfoCard
            no={"2"}
            image={require("../../../images/landing/RegurlatoryApproval.jpg")}
            title={"Regulatory Approval"}
            paragraph={
              "Medicine that has not been approved in SA by SAHPRA is classified as “Unregistered Medicine” Unregistered Medicine requires SAHPRA to approve the importation and the use thereof under Section 21 of the Medicine Act. Alter-pharm assists the patient with such  Regulatory Approval, along with a medical prescription  by a Medical Practitioner"
            }
          />
          <InfoCard
            no={"3"}
            image={require("../../../images/landing/florist.jpg")}
            title={"Cultivation & Manufacture"}
            paragraph={
              "Alter-Pharm sources from GACP-compliant, Section 22C-licensed cultivators. All product is processed and packaged by a GMP-certified pharmaceutical manufacturer."
            }
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            //   borderStyle: "solid",
            display: "flex",

            minHeight: 200,
            justifyContent: "space-between",
            flexDirection: width > 599 ? "row" : "column",
          }}
        >
          <InfoCard
            no={"4"}
            image={require("../../../images/landing/ProductValidationandQa.png")}
            title={"Product Validation & QA"}
            paragraph={
              "Each batch undergoes rigorous quality assurance, independently lab-tested for potency, contaminants, and active pharmaceutical ingredient. Products are packaged in tamper-evident, patient-labelled containers."
            }
          />
          <InfoCard
            no={"5"}
            image={require("../../../images/landing/controlledDistribution.jpg")}
            title={"Controlled Distribution"}
            paragraph={
              "Once approved, medication is shipped via licensed courier to either"
            }
          />
          <InfoCard
            no={"6"}
            image={require("../../../images/landing/Dispensaryand handover.jpg")}
            title={"Dispensing & Handover"}
            paragraph={
              "Patients collect their prescription at a partner pharmacy or delivery point, following identity and script verification by a pharmacist or dispensing agent."
            }
          />
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 20,
          marginBottom: 40,
        }}
      >
        <BaseButton
          label={"Learn More"}
          marginRight={20}
          width={140}
          href={
            "https://www.google.com/search?q=sahpra&sca_esv=5ea039d3f5929d6f&rlz=1C5CHFA_enZA1125ZA1125&sxsrf=AHTn8zqv39llh0lfhJZ6pfisHQDHgpI0AQ%3A1747477514356&ei=CmQoaPG_FaGWxc8P8dyI2Ak&ved=0ahUKEwjx7PuDpaqNAxUhS_EDHXEuApsQ4dUDCBA&uact=5&oq=sahpra&gs_lp=Egxnd3Mtd2l6LXNlcnAiBnNhaHByYTIKECMYgAQYJxiKBTIKEAAYgAQYQxiKBTIKEAAYgAQYFBiHAjILEAAYgAQYkQIYigUyBRAAGIAEMgoQABiABBhDGIoFMgUQABiABDIFEAAYgAQyBRAAGIAEMgoQABiABBhDGIoFSKcZUMEOWLMXcAF4AZABAJgBrwKgAZ4LqgEFMi00LjG4AQPIAQD4AQGYAgagAsQLwgIKEAAYsAMY1gQYR8ICBBAjGCfCAg0QLhiABBhDGNQCGIoFwgIREC4YgAQYkQIYxwEYigUYrwHCAgoQLhiABBhDGIoFwgINEC4YgAQYsQMYQxiKBcICEBAuGIAEGLEDGEMYgwEYigWYAwCIBgGQBgiSBwcxLjAuMy4yoAfDRbIHBTItMy4yuAe8C8IHAzItNsgHJA&sclient=gws-wiz-serp"
          }
        />
        <BaseButton label={"Sign Up"} width={140} onClick={onSignUpClick} />
      </div>
    </div>
  );
};

export default InfoPanel;
